import { useTranslation } from 'react-i18next';

import { Confirmation } from 'core/components';
import { IJobCustomer } from 'jobs/types';
import { Color } from 'theme/enums';

interface IProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  customers: IJobCustomer[];
}

export const RemoveCustomersConfirmation = ({ isOpen, onConfirm, onCancel, customers }: IProps) => {
  const { t } = useTranslation();

  const getConfirmationMessage = () => {
    return t('messageConfirmRemoveCustomers', {
      count: customers.length,
      customerName:
        customers.length === 1
          ? customers[0].foreignContactGroupName || t('labelTheCustomer')
          : undefined,
    });
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Confirmation
      isOpen={true}
      title={t('titleRemoveCustomer', { count: customers.length })}
      message={getConfirmationMessage()}
      confirmBtnLabel={t('buttonLabelRemove')}
      confirmBtnColor={Color.DANGER}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
